export default __webpack_public_path__ + "static/media/visa-card.97c1bd1e.svg";